'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarmaladeThemeProvider = undefined;
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _glamorous = require('glamorous');
var _glamor = require('glamor');
var _propTypes = require('prop-types');
var _marmaladeTheme = require('./marmalade-theme');
var _marmaladeTheme2 = _interopRequireDefault(_marmaladeTheme);
var _mediaQueries = require('./media-queries');
var _specificityPlugin = require('./specificity-plugin');
require('glamor/reset');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
_glamor.plugins.add((0, _specificityPlugin.getSpecificityPlugin)());
var MarmaladeThemeProvider = exports.MarmaladeThemeProvider = function (_Component) {
  _inherits(MarmaladeThemeProvider, _Component);
  function MarmaladeThemeProvider() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, MarmaladeThemeProvider);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MarmaladeThemeProvider.__proto__ || Object.getPrototypeOf(MarmaladeThemeProvider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      theme: Object.assign({}, _marmaladeTheme2.default, _this.props.subTheme)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(MarmaladeThemeProvider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.createGlobalStyles();
    }
  }, {
    key: 'createGlobalStyles',
    value: function createGlobalStyles() {
      // This uses raw glamor to set global styles, it's a bit painful.
      var theme = this.state.theme;
      _glamor.css.global('*', {
        boxSizing: 'border-box',
        textRendering: 'optimizeLegibility',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale'
      });
      _glamor.css.insert('html {\n            font-size: ' + theme.base + ';\n            background-color: ' + theme.Html_backgroundColor + ';\n            min-width: 320px;\n        }');
      _glamor.css.insert('body {\n            line-height: ' + theme.lineHeight + ';\n            letter-spacing: .2px;\n            color: ' + theme.colorBase + ';\n            font-family: ' + theme.font + ';\n            font-size: ' + theme.fontSize + ';\n            font-weight: ' + theme.fontWeight + ';\n        }');
      _glamor.css.global('a', {
        cursor: 'pointer',
        textDecoration: theme.A_textDecoration,
        color: theme.A_color
      });
      _glamor.css.global('a:hover', {
        textDecoration: theme.A_textDecoration_hover || theme.A_textDecoration,
        color: theme.A_color_hover || theme.A_color
      });
      _glamor.css.global('img', {
        maxWidth: '100%',
        height: 'auto'
      });
      _glamor.css.global('hr', {
        border: 'none',
        borderTop: theme.colorGreyLight,
        padding: 0,
        margin: theme.space_md + ' 0'
      });
      _glamor.css.global('li', {
        marginBottom: theme.space_sm
      });
      _glamor.css.global('p', {
        margin: '0 0 ' + theme.space_sm
      });
      _glamor.css.global('h1, h2, h3, h4, h5, h6', {
        margin: '0 0 1em',
        lineHeight: '1.3'
      });
      _glamor.css.global('h1', {
        fontSize: '3.6rem'
      });
      _glamor.css.global('h2', {
        fontSize: '2.6rem'
      });
      _glamor.css.global('h3', {
        fontSize: '2.2rem'
      });
      _glamor.css.global('h4', {
        fontSize: '1.8rem'
      });
      _glamor.css.global('h5', {
        fontSize: '1.6rem'
      });
      _glamor.css.global('h6', {
        fontSize: '1.4rem'
      });
      _glamor.css.global('h1, h2, h3, h4, h5, h6', {
        fontFamily: theme.titleFont,
        fontWeight: theme.titleFontWeight,
        color: theme.titleColor
      });

      // Insert does the same thing as global but in a slightly different format that allows you to use media queries.
      // You can only insert one rule at a time
      _glamor.css.insert((0, _mediaQueries.atLeast)(theme.breakpoint_sm) + ' {\n            body { font-size: ' + theme.fontSizeLarger + '; }\n            h1 { font-size: 4.6rem; }\n            h2 { font-size: 3rem; }\n            h3 { font-size: 2.4rem; }\n            h4 { font-size: 2rem; }\n            h5 { font-size: 1.8rem; }\n            h6 { font-size: 1.6rem; }\n        }');
      // Deal with firefox not aligning text right in fixed height select inputs
      _glamor.css.insert('@-moz-document url-prefix() { select { padding-top: 13px !important;}}');
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_glamorous.ThemeProvider, {
        theme: this.state.theme
      }, this.props.children);
    }
  }]);
  return MarmaladeThemeProvider;
}(_react.Component);
MarmaladeThemeProvider.propTypes = {
  children: _propTypes.node,
  subTheme: _propTypes.object
};
MarmaladeThemeProvider.defaultProps = {
  subTheme: {}
};
exports.default = MarmaladeThemeProvider;